/* eslint-disable react-hooks/exhaustive-deps  */
/* eslint-disable array-callback-return  */
import React, { Fragment, useCallback, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import storage from 'app/services/session';
import useConfig from 'app/hooks/useConfig';
import { Order as OrderContainer } from 'app/modules/order';
import { Button, Modal, ModalTypical } from 'app/components';
import { NavLink, generatePath, useHistory, useLocation } from 'react-router-dom';
import SuccessContainer from '../Success';
import { useModal } from 'app/hooks';
import { RefundModalContent } from 'app/modules/account/Tickets/styles';

const propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  }).isRequired,

  match: PropTypes.shape({
    params: PropTypes.shape({
      userSessionId: PropTypes.string
    }).isRequired
  }).isRequired,

  error: PropTypes.shape({
    type: PropTypes.string.isRequired,
    codes: PropTypes.object.isRequired
  }),

  clearErrorApi: PropTypes.func.isRequired,
  fetchPurchase: PropTypes.func.isRequired,
  booking: PropTypes.func.isRequired,
  fetchTickets: PropTypes.func.isRequired,
  clearOrder: PropTypes.func.isRequired,
  setLoaderData: PropTypes.func.isRequired
};

const defaultProps = {
  error: null
};

const BookingSuccess = ({
  history: { push },
  match: {
    params: { userSessionId }
  },
  error,
  clearErrorApi,
  fetchPurchase,
  fetchTickets,
  clearOrder,
  booking,
  setLoaderData
}) => {
  const [t] = useTranslation();
  const {
    routes,
    supportInfo: { email }
  } = useConfig();
  const [isContactModal, setContactModal] = useState(false);
  const [isOutOfTimeModal, setOutOfTimeModal] = useState(false);
  const [isBonusModal, setIsBonusModal] = useState(false);
  const [isBonusSuccess, setIsBonusSuccess] = useState(false);
  const [bookingData, setBookingData] = useState(null);
  const [isShowValidUser, showValidUserModal, hideValidUserModal] = useModal('pickupModal');
  const history = useHistory();

  // eslint-disable-next-line

  const closeCb = useCallback(() =>
    push(routes.fallback.pattern)
    , []);
  const isBonus = storage.getIsAppliedBonusGiftCard();

  const fetch = useCallback(fetchPurchase.bind(null, userSessionId), [
    userSessionId,
    fetchPurchase
  ]);
  const getTickets = useCallback(fetchTickets.bind(null, userSessionId), [
    userSessionId,
    fetchTickets
  ]);

  useEffect(() => {
    clearErrorApi();

    return () => {
      storage.setIsLastBonusCardRecharge(false);
      clearOrder();
    };
  }, []);


  // noindex tag 
  useEffect(() => {
    const metaTag = document.createElement('meta');
    metaTag.name = "robots";
    metaTag.content = "noindex";

    document.head.appendChild(metaTag);

    return () => {
      document.head.removeChild(metaTag);
    };
  }, []);

  useEffect(() => {
    if (error && error.type === error.codes.OUT_OF_TIME) {
      setOutOfTimeModal(true);
    } else if (error && error.type && storage.getIsLastBonusCardRecharge() === 'true') {
      setIsBonusModal(true);
    } else if (error && error.type) {
      setContactModal(true);
    }
  }, [error]);


  useEffect(() => {
    if (booking) {
      setBookingData(booking);
      setIsBonusSuccess(true);
    }
  }, [booking])

  const handleHomePage = () => {
    hideValidUserModal();
  };

  const handlePickupNow = () => {
    hideValidUserModal();
    const movieCinemaId = bookingData?.cinemaId || 1003;
    const bookingId = bookingData?.bookingId || "WLIAKDKS";
    history.push({
      pathname: generatePath(routes.pickupSnacks.pattern, { movieCinemaId, bookingId }),
      state: { isPickupReady: true }
    });
  };
  useEffect(() => {
    setLoaderData(true)
    const timer = setTimeout(() => {
      if (isBonus === false || isBonus === null) {
        fetch()
      }
      getTickets()
      setLoaderData(false)
    }, 4000);


    return () => clearTimeout(timer);
  }, [userSessionId])

  useEffect(() => {
    const handleBrowserBackClick = event => {
      push(routes.movies.pattern)
    };

    window.addEventListener('popstate', handleBrowserBackClick);
    window.history.pushState(null, null, window.location.href);

    return () => {
      setTimeout(() => {
        window.removeEventListener('popstate', handleBrowserBackClick);
      }, 5000)
    };
  }, []);
  const location = useLocation();
  if (location.state) {
    window.location.reload();
  }

  useEffect(() => {
    const isPurchaseSent = sessionStorage.getItem('isPurchaseSent');
    if (bookingData) {
      const { tickets } = bookingData;
      if (process.env.REACT_APP_COUNTRY === 'hrv' && !isPurchaseSent) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          'event': 'purchase',
          'ecommerce': {
            'currency': 'EUR',
            'transaction_id': tickets.bookingNumber,
            'affiliation': tickets.cinemaName,
            'value': tickets.totalValueCents,
            'items': tickets?.map(item => ({
              'item_name': item.movieName,
              'item_id': `${item.sessionId}-${item.seatNumber}-${item.rowNumber}`,
              'price': item.priceInCents,
              'quantity': item.quantity
            }))
          }
        });
      }
      sessionStorage.setItem('isPurchaseSent', true);
    }
  }, [bookingData]);

  useEffect(() => {
    if (bookingData?.concessions?.length > 0) {
      setTimeout(() => {
        showValidUserModal();
      }, 3000)
    }
  }, [bookingData]);
  return (
    <Fragment>

      {
        // for opera ticket booking
        bookingData?.session?.eventId ? (<SuccessContainer
          render={({ fetchPDF }) => (
            <OrderContainer
              title={t('purchase.payment_success.operaTitle')}
              label={t('purchase.payment_success.label')}
              info={t('purchase.payment_success.info')}
              fetch={fetch}
              getTickets={getTickets}
            >
              <Button to={routes.fallback.pattern} className="b-order__actions-btn" isDefault>
                {t('common.to_home_page')}
              </Button>
              <Button onClick={fetchPDF} className="b-order__actions-btn" isPrimary>
                {t('common.download_tickets')}
              </Button>
            </OrderContainer>
          )}
        />)
          :
          // for normal ticket booking
          // {bookingData?.tickets?.length > 0 &&
          (
            <SuccessContainer
              render={({ fetchPDF }) => (
                <OrderContainer
                  title={t('purchase.payment_success.title')}
                  label={t('purchase.payment_success.label')}
                  info={t('purchase.payment_success.info')}
                  fetch={fetch}
                  getTickets={getTickets}
                >
                  <Button to={routes.fallback.pattern} className="b-order__actions-btn" isDefault>
                    {t('common.to_home_page')}
                  </Button>
                  <Button onClick={fetchPDF} className="b-order__actions-btn" isPrimary>
                    {t('common.download_tickets')}
                  </Button>
                </OrderContainer>
              )} />
          )
      }

      {/* bonus card recharge successful */}
      {bookingData?.tickets?.length === 0 &&
        <Modal
          isSmall
          isOpen={isBonusSuccess}
          // close={closeCb2}
          title={t('purchase.modals.bonus_card_recharge_success.header')}
        >
          <ModalTypical
            iconId="complete"
            title={t('purchase.modals.bonus_card_recharge_success.title')}
            message={t('purchase.modals.bonus_card_recharge_success.message')}
          >
            <NavLink to={routes.bonusCard.pattern}>
              <Button isPrimary style={{ width: '200px' }}>
                {t('common.ok')}
              </Button>
            </NavLink>
          </ModalTypical>
        </Modal>

      }

      {/* order failed */}
      <Modal
        isSmall
        isOpen={isContactModal}
        close={closeCb}
        title={t('purchase.modals.payment_contact.header')}
      >
        <ModalTypical
          iconId="cross-circled"
          title={t('purchase.modals.payment_contact.title')}
          message={t('purchase.modals.payment_contact.message', { email })}
        >
          <Button href={`mailto:${email}`} as="a" isPrimary>
            {t('purchase.modals.payment_contact.button')}
          </Button>
        </ModalTypical>
      </Modal>

      {/* recharge failed */}
      <Modal
        isSmall
        isOpen={isBonusModal}
        close={closeCb}
        title={t('purchase.modals.bonus_card_recharge_fail.header')}
      >
        <ModalTypical
          iconId="cross-circled"
          title={t('purchase.modals.bonus_card_recharge_fail.title')}
          message={t('purchase.modals.bonus_card_recharge_fail.message')}
        >
          <Button href={routes.movies.pattern} as="a" isPrimary style={{ width: '200px' }}>
            {t('common.ok')}
          </Button>
        </ModalTypical>
      </Modal>

      {/* payment time up to due */}
      <Modal
        isSmall
        isOpen={isOutOfTimeModal}
        close={closeCb}
        title={t('purchase.modals.payment_outOfTime.header')}
      >
        <ModalTypical
          iconId="clock-circled"
          title={t('purchase.modals.payment_outOfTime.title')}
          message={t('purchase.modals.payment_outOfTime.message')}
        >
          <div />
        </ModalTypical>
      </Modal>

      {/* Tickets are booked with concessions */}
      <Modal
        isOpen={isShowValidUser}
        // title={t('purchase.modals.invalid_user_opera_booking.header')}
        title={`Pickup Snacks`}
        close={handleHomePage}
        style={{ pointerEvents: 'none' }}
        shouldCloseOnOverlayClick={false}
      >
        <RefundModalContent>
          <div className="refund_modal__modal_message">
            {/* <h3>{t('purchase.modals.invalid_user_opera_booking.label')}</h3> */}
            {/* <h3>{t('purchase.modals.invalid_user_opera_booking.info')}</h3> */}
            <h3>{`After Confirmation Snacks will be starts preparing now.`}</h3>
          </div>
          <div className="seasonPass__modal_btns">
            <Button isDefault onClick={handlePickupNow} style={{ textAlign: 'center', cursor: 'pointer', marginRight: '10px' }}>
              {/* {t('common.cancel')} */}
              {`Pickup Now`}
            </Button>
            <Button isPrimary onClick={handleHomePage}>
              {/* {t('common.login')} */}
              {`Pickup Later`}
            </Button>
          </div>
        </RefundModalContent>
      </Modal>
    </Fragment>
  );
};

BookingSuccess.defaultProps = defaultProps;
BookingSuccess.propTypes = propTypes;
export default BookingSuccess;
